import { FC, ReactNode } from 'react';

/** Frozen issuance rows show their details as read-only cards, per the design. */
export const ReadOnlyField: FC<{ label: ReactNode; value: ReactNode }> = ({ label, value }) => (
  <div className="flex min-w-0 flex-col gap-1 rounded-md bg-gray-50 px-3 py-2">
    <span className="truncate text-[10px] font-normal leading-4 text-gray-500">{label}</span>
    <span className="truncate text-sm font-[450] text-gray-700">{value}</span>
  </div>
);
